import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiCalloutContent' })(
  ({ breakpoints, typography }) => ({
    container: {
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'right',
      backgroundSize: 'cover',
    },
    item: {
      paddingBottom: typography.pxToRem(36),
    },
    buttons: {
      paddingLeft: typography.pxToRem(30),
      gap: typography.pxToRem(12),
      display: 'flex',
      flexWrap: 'wrap',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        display: 'inline-grid',
      },
    },
  })
);

export default useStyles;
